export const EN_MASONRY_CONTENT_STRINGS = {
  MASONRY_GENERIC_CONTENT: 'Masonry Content',
  MASONRY_GENERIC_CONTENT_METADATA_LABEL: 'Metadata',
  MASONRY_GENERIC_CONTENT_EASY_ID_LABEL: 'Easy ID',
  MASONRY_GENERIC_CONTENT_EASY_ID_HINT:
    'Optional readable, unique-per-space ID used in place of the Contentful entry ID. Leave blank to use the auto-generated entry ID.',
  MASONRY_GENERIC_CONTENT_NAME_LABEL: 'Content Name',
  MASONRY_GENERIC_CONTENT_NAME_HINT:
    'Internal unique name for this content entry. Must be unique within the Contentful space.',
  MASONRY_GENERIC_CONTENT_COMPONENT_TYPE_LABEL: 'Component Type',
  MASONRY_GENERIC_CONTENT_COMPONENT_TYPE_HINT:
    'Required masonry component-type. Select the variant this content is authored for.',
  MASONRY_GENERIC_CONTENT_CONTENT_LABEL: 'Content',
  MASONRY_GENERIC_CONTENT_HEADING_LABEL: 'Heading',
  MASONRY_GENERIC_CONTENT_TITLE_LABEL: 'Title',
  MASONRY_GENERIC_CONTENT_EYEBROW_LABEL: 'Eyebrow',
  MASONRY_GENERIC_CONTENT_BODY_LABEL: 'Body',
  MASONRY_GENERIC_CONTENT_BODY_HINT:
    'Rich text body. Stored as a Contentful RichText document.',
  MASONRY_GENERIC_CONTENT_BUTTON_LABEL_LABEL: 'Button Label',
  MASONRY_GENERIC_CONTENT_BUTTON_ACTION_LABEL: 'Button Action',
  MASONRY_GENERIC_CONTENT_BUTTON_ACTION_HINT:
    'Target URL or deeplink for the primary action.',
  MASONRY_GENERIC_CONTENT_BUTTON_INDICATOR_LABEL: 'Button Indicator',
  MASONRY_GENERIC_CONTENT_BUTTON_INDICATOR_PLACEHOLDER: 'Select indicator',
  MASONRY_GENERIC_CONTENT_BUTTON_INDICATOR_NONE: 'None',
  MASONRY_GENERIC_CONTENT_BUTTON_INDICATOR_NEW_WINDOW_INTERNAL:
    'New window (internal)',
  MASONRY_GENERIC_CONTENT_BUTTON_INDICATOR_NEW_WINDOW_EXTERNAL:
    'New window (external)',
  MASONRY_GENERIC_CONTENT_BUTTON_INDICATOR_EXTERNAL_LINK: 'External link',
  MASONRY_GENERIC_CONTENT_IMAGE_LABEL: 'Image (Contentful Asset ID)',
  MASONRY_GENERIC_CONTENT_IMAGE_HINT:
    'Contentful Asset ID for the image. Find it on the asset page in the Contentful web app. The asset must be published in this Contentful space.',
  MASONRY_GENERIC_CONTENT_ICON_LABEL: 'Icon (Contentful Asset ID)',
  MASONRY_GENERIC_CONTENT_ICON_HINT:
    'Contentful Asset ID for the icon. Find it on the asset page in the Contentful web app. The asset must be published in this Contentful space.',
  MASONRY_GENERIC_CONTENT_IMAGE_ALT_TEXT_LABEL: 'Image Alt Text',
  MASONRY_GENERIC_CONTENT_URL_LABEL: 'URL',
  MASONRY_GENERIC_CONTENT_URL_HINT:
    'Target URL the entry links to. Used by resolvers that expose a url datapoint.',
  MASONRY_GENERIC_CONTENT_HEADER_BUTTON_LABEL_LABEL: 'Header Button Label',
  MASONRY_GENERIC_CONTENT_SUBHEADING_LABEL: 'Subheading',
  MASONRY_GENERIC_CONTENT_INFO_LABEL: 'Info',
  MASONRY_GENERIC_CONTENT_HEADING_LEVEL_LABEL: 'Heading Level',
  MASONRY_GENERIC_CONTENT_HEADING_LEVEL_HINT:
    'Semantic heading level (e.g. 1–6). Controls render priority; same across locales.',
  MASONRY_GENERIC_CONTENT_PROGRESS_LABEL: 'Progress',
  MASONRY_GENERIC_CONTENT_PROGRESS_HINT:
    'Integer progress value used by progress-style components. Same across locales.',
  MASONRY_GENERIC_CONTENT_KEY_VALUES_LABEL: 'Key Values',
  MASONRY_GENERIC_CONTENT_KEY_VALUES_HINT:
    'Linked masonryKeyValue entries. Read-only in this view; edit in Contentful directly.',
  MASONRY_GENERIC_CONTENT_KEY_VALUE_ITEM_LABEL: 'Key Value',
  MASONRY_GENERIC_CONTENT_KEY_VALUE_KEY_LABEL: 'Key',
  MASONRY_GENERIC_CONTENT_KEY_VALUE_VALUE_LABEL: 'Value',
  MASONRY_GENERIC_CONTENT_ITEMS_LABEL: 'Items',
  MASONRY_GENERIC_CONTENT_ITEMS_HINT:
    'Other Masonry Content entries to display inside this one. Pick existing entries; the underlying widget bookkeeping is handled automatically.',
  MASONRY_GENERIC_CONTENT_ITEM_LABEL: 'Item',
  MASONRY_GENERIC_CONTENT_BADGES_LABEL: 'Badges',
  MASONRY_GENERIC_CONTENT_BADGES_HINT:
    'Other Masonry Content entries to display as badges. Typically small entries with just an image, alt text, and title set.',
  MASONRY_GENERIC_CONTENT_BADGE_LABEL: 'Badge',
};
